var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H20.1667V18.3333H0V0ZM9.07501 13.75H11.0917V14.8958H9.07501V13.75ZM14.1167 10.3125H12.1V14.8958H14.1167V10.3125ZM15.125 8.02082H17.1417V14.8958H15.125V8.02082ZM18.15 2.29169H2.01664V4.58332H18.15V2.29169ZM9.07501 10.8854C9.07501 13.1003 7.49492 14.8958 5.54583 14.8958C3.59673 14.8958 2.01664 13.1003 2.01664 10.8854C2.01664 8.67051 3.59673 6.87501 5.54583 6.87501C7.49492 6.87501 9.07501 8.67051 9.07501 10.8854ZM6.64584 8.30796C6.303 8.11894 5.92689 8.02077 5.54583 8.02082V10.8854L7.99712 11.5536C8.13114 10.9186 8.07022 10.2506 7.82447 9.66037C7.57872 9.07009 7.16288 8.59294 6.64584 8.30796Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.6c29c4ba745067d46ab34db3e7bbb32e.svg";
export { ForwardRef as ReactComponent };